import InitPaymentLogic from "./Payment.logic";

const PaymentComponent: React.FC = () => {
    const { selectedClients, clients, data, trainingTypeRef, trainingsTypes, onSave, onChange, addClient, removeSelectedClient } = InitPaymentLogic();

    const selectedTypeId = +data.trainingType;
    const selectedType = trainingsTypes.find((t) => t.id === selectedTypeId);
    const typeQuantity = selectedType?.quantity ?? 1;
    const showQuantity = typeQuantity === 1;

    const getExpectedPrice = (client: any): number => {
        const clientPrice = client.prices?.find((p: any) => p.trainingTypeId === selectedTypeId);
        const unitPrice = clientPrice?.price ?? selectedType?.price ?? 0;
        const qty = showQuantity ? +data.quantity : 1;
        return unitPrice * typeQuantity * qty;
    };

    return (
        <div className="page-container">
            <h1 className="text-align-center">Uplata</h1>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <button className="btn-primary" type="button" onClick={onSave}>Sačuvaj</button>

                <div>
                    <label htmlFor="trainingType">Tip treninga</label>
                    <select id="trainingType" aria-label={"Izaberi tip treninga"} ref={trainingTypeRef} onChange={onChange} name="trainingType" value={data.trainingType}>
                        {trainingsTypes.map((t) => (
                            <option key={t.id} value={t.id}>{t.name}</option>
                        ))}
                    </select>
                </div>

                {showQuantity && (
                    <div>
                        <label htmlFor="quantity">Količina</label>
                        <input id="quantity" type={"number"} min={1} step={1} inputMode={"numeric"} value={data.quantity} onChange={onChange} name="quantity"></input>
                    </div>
                )}

                <div>
                    <label htmlFor="price">Iznos u dinarima</label>
                    <input id="price" type={"number"} min={0} step={1} inputMode={"numeric"} value={data.price} onChange={onChange} name="price"></input>
                </div>

                <div>
                    <label htmlFor="date">Datum i vreme uplate</label>
                    <input id="date" type={"datetime-local"} value={data.date} onChange={onChange} name="date"></input>
                </div>

                <div>
                    <label htmlFor="client">Pretraga klijenata</label>
                    <input placeholder="Traži po imenu ili prezimenu..." id="client" type={"text"} value={data.client} onChange={onChange} name="client"></input>
                </div>
            </div>

            {selectedClients.length > 0 && (
                <div className="card" style={{ marginTop: '16px' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        {selectedClients.map((c) =>
                            <button className="btn-secondary" type="button" key={c.id} onClick={() => removeSelectedClient(c)}>{c.firstName} {c.lastName} [{getExpectedPrice(c)}]</button>
                        )}
                    </div>
                </div>
            )}

            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '12px' }}>
                {clients.map((c) => c.firstName.concat(" ", c.lastName).toLowerCase().replaceAll("ć", "c").replaceAll("č", "c").replaceAll("š", "s").replaceAll("ž", "z").replaceAll("đ", "dj").includes(data.client.toLowerCase().replaceAll("ć", "c").replaceAll("č", "c").replaceAll("š", "s").replaceAll("ž", "z").replaceAll("đ", "dj")) ? (
                    <button type="button" key={c.id} onClick={() => addClient(c)}>{c.firstName} {c.lastName} [{getExpectedPrice(c)}]</button>
                ) : "")
                }
            </div>

            <div style={{ marginTop: '16px' }}>
                <button className="btn-primary" type="button" onClick={onSave}>Sačuvaj</button>
            </div>
        </div>
    );
}

export default PaymentComponent;
